/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
  // Add custom code below this line

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  /* -----------------------------------------------------------------------
   * Smile.io rewards launcher position (bottom-left, above the GET 10% OFF
   * banner). Smile respects normal CSS, so a stylesheet is enough here.
   * --------------------------------------------------------------------- */
  var smileCss = [
    '#smile-ui-lite-launcher-frame-container,',
    '#smile-ui-lite-container {',
    '  left: 16px !important;',
    '  right: auto !important;',
    '  bottom: 24px !important;',
    '}',
    '@media only screen and (max-width: 749px) {',
    '  #smile-ui-lite-launcher-frame-container,',
    '  #smile-ui-lite-container {',
    '    left: 12px !important;',
    '    bottom: 72px !important;',
    '  }',
    '}',
    '@media only screen and (max-width: 749px) {',
    '  body.template-cart #smile-ui-lite-launcher-frame-container,',
    '  body.template-cart #smile-ui-lite-container {',
    '    bottom: 150px !important;',
    '  }',
    '}',
    /* Hide the rewards launcher while the cart drawer is open (toggled via body class). */
    'body.viva-hide-widgets #smile-ui-lite-launcher-frame-container,',
    'body.viva-hide-widgets #smile-ui-lite-container {',
    '  opacity: 0 !important;',
    '  visibility: hidden !important;',
    '  pointer-events: none !important;',
    '}'
  ].join('\n');

  var smileStyle = document.createElement('style');
  smileStyle.setAttribute('data-app-widget-position', 'smile');
  smileStyle.appendChild(document.createTextNode(smileCss));
  document.head.appendChild(smileStyle);

  /* -----------------------------------------------------------------------
   * Tidio live chat.
   * Tidio's current widget uses the selector "#tidio" (the old
   * "#tidio-chat-iframe" no longer exists), and it manages its own inline
   * styles, so plain CSS from the theme does not stick. We use Tidio's
   * official JS API instead: adjustStyles() for position and hide()/show()
   * to toggle it with the cart drawer.
   * --------------------------------------------------------------------- */
  var TIDIO_COLOR = '#DCD7CF';

  function positionTidio() {
    if (!window.tidioChatApi) return;

    // Brand color (official Tidio API). Works only after the widget is ready.
    try {
      if (typeof window.tidioChatApi.setColorPalette === 'function') {
        window.tidioChatApi.setColorPalette(TIDIO_COLOR);
      }
    } catch (e) {}

    if (typeof window.tidioChatApi.adjustStyles !== 'function') return;
    try {
      window.tidioChatApi.adjustStyles('#tidio { bottom: 24px !important; right: 16px !important; left: auto !important; }');
      window.tidioChatApi.adjustStyles(
        '@media only screen and (max-width: 749px) { #tidio { bottom: 72px !important; right: 12px !important; left: auto !important; } }'
      );
    } catch (e) {}
  }

  function onTidioReady() {
    positionTidio();
  }

  if (window.tidioChatApi) {
    window.tidioChatApi.on('ready', onTidioReady);
    positionTidio();
  } else {
    document.addEventListener('tidioChat-ready', onTidioReady);
  }

  /* -----------------------------------------------------------------------
   * Hide floating widgets while the cart drawer is open (mobile), show them
   * again when it closes.
   * --------------------------------------------------------------------- */
  function setSmileHidden(hidden) {
    // Toggle a body class; the CSS rule (with !important) survives Smile
    // re-rendering its own inline styles.
    document.body.classList.toggle('viva-hide-widgets', hidden);
  }

  function setTidioHidden(hidden) {
    if (!window.tidioChatApi) return;
    try {
      if (hidden) {
        window.tidioChatApi.hide();
      } else {
        window.tidioChatApi.show();
      }
    } catch (e) {}
  }

  var cartOpen = false;
  function setCartOpen(open) {
    if (open === cartOpen) return;
    cartOpen = open;

    // Only hide on mobile; always restore when closing.
    if (open && !isMobile()) return;

    setSmileHidden(open);
    setTidioHidden(open);
  }

  document.addEventListener('theme:cart-drawer:open', function () {
    setCartOpen(true);
  });
  document.addEventListener('theme:cart-drawer:close', function () {
    setCartOpen(false);
  });

  // Fallback: watch the <cart-drawer> element's "is-open" class directly, in
  // case the events above are missed.
  function watchCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    new MutationObserver(function () {
      setCartOpen(drawer.classList.contains('is-open'));
    }).observe(drawer, {attributes: true, attributeFilter: ['class']});
    return true;
  }

  if (!watchCartDrawer()) {
    var tries = 0;
    var timer = setInterval(function () {
      if (watchCartDrawer() || ++tries > 20) clearInterval(timer);
    }, 500);
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
